import { useState, useEffect } from 'react';

const GUEST_LIST_KEY = 'nutrius_guest_list';

export const useGuestList = () => {
  const [guestList, setGuestList] = useState(null);

  useEffect(() => {
    // Load guest list from localStorage
    const stored = localStorage.getItem(GUEST_LIST_KEY);
    if (stored) {
      try {
        setGuestList(JSON.parse(stored));
      } catch (error) {
        console.error('Error loading guest list:', error);
        initializeGuestList();
      }
    } else {
      initializeGuestList();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initializeGuestList = () => {
    const newList = {
      id: 'guest-list',
      name: 'My Shopping List',
      items: [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    setGuestList(newList);
    saveToLocalStorage(newList);
  };

  const saveToLocalStorage = (list) => {
    localStorage.setItem(GUEST_LIST_KEY, JSON.stringify(list));
  };

  const addItem = (item) => {
    const newItem = {
      ...item,
      id: `guest_${Date.now()}_${Math.random()}`,
      addedAt: new Date().toISOString()
    };

    const updatedList = {
      ...guestList,
      items: [...(guestList?.items || []), newItem],
      updatedAt: new Date().toISOString()
    };

    setGuestList(updatedList);
    saveToLocalStorage(updatedList);
  };

  const removeItem = (itemId) => {
    const updatedList = {
      ...guestList,
      items: (guestList?.items || []).filter(item => item.id !== itemId),
      updatedAt: new Date().toISOString()
    };

    setGuestList(updatedList);
    saveToLocalStorage(updatedList);
  };

  const updateItem = (itemId, updates) => {
    const updatedList = {
      ...guestList,
      items: (guestList?.items || []).map(item =>
        item.id === itemId ? { ...item, ...updates } : item
      ),
      updatedAt: new Date().toISOString()
    };

    setGuestList(updatedList);
    saveToLocalStorage(updatedList);
  };

  const clearList = () => {
    const clearedList = {
      ...guestList,
      items: [],
      updatedAt: new Date().toISOString()
    };

    setGuestList(clearedList);
    saveToLocalStorage(clearedList);
  };

  return {
    guestList,
    addItem,
    removeItem,
    updateItem,
    clearList
  };
};
